import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { GetMarketingFlowResponse } from "../../marketing.types";

export const requestGetMarketingFlow = async (
  flowId: string
): Promise<GetMarketingFlowResponse> => {
  return await instance.get(`${ApiRoutesMarketing.Flows}/${flowId}`);
};
